/* Partners Block JS File */
$(document).ready(function() {

});
